<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Categoria de Bandeiras</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar Filtro"
              @click="ResetListBrand()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">
                  Bandeiras
                </h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-0">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" :class="window.width < 1880 ? 'dropleft' : ''">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis col-lg-12"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar Relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-12" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0">Nome</th>
                    <th scope="col" class="border-0">Código do Facilitador</th>
                    <th scope="col" class="border-0">Arranjo de débito</th>
                    <th scope="col" class="border-0">Arranjo de crédito</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(Brand, index) in Brands" :key="index">
                    <td>{{ Brand.Code }}</td>
                    <td>{{ Brand.Name }}</td>
                    <td>{{ Brand.CodeFacilitator }}</td>
                    <td>{{ Brand.PaymentSchemeCredit != 0 ? Brand.PaymentSchemeCredit : "-" }}</td>
                    <td>{{ Brand.PaymentSchemeDebit != 0 ? Brand.PaymentSchemeDebit : "-" }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="$isAuthorize('Brand', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="OpenBrands($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('Brand', 'Update') && !Brand.IsExcluded"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="OpenBrands($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('Brand', 'Delete') && !Brand.IsExcluded"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="ConfirmDeleteBrands(Brand.Name, Brand.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="Brands == undefined || Brands == null || Brands.length == 0">
                    <td colspan="6">Sem Registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      id="mFormBrands"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>

      <div v-else>
        <ValidationObserver tag="form" ref="BrandsValidationForm">
          <d-form-row>
            <d-col v-if="pOpened != null" md="6" class="form-group">
              <label>Código</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedBrandsForm | showValidateError(invalid)"
                  :disabled="true"
                  type="text"
                  v-model="infoBrand.Code"
                />
                <div class="invalid-feedback d-block" v-if="validatedBrandsForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedBrandsForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoBrand.Name"
                />
                <div class="invalid-feedback d-block" v-if="validatedBrandsForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <d-col md="6" class="form-group">
              <label>Código do facilitador</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedBrandsForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="number"
                  v-model="infoBrand.CodeFacilitator"
                />

                <div class="invalid-feedback d-block" v-if="validatedBrandsForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <!-- Arranjo de débito -->
              <label>Arranjo de débito</label>
              <ValidationProvider v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedBrandsForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoBrand.PaymentSchemeDebit"
                />

                <div class="invalid-feedback d-block" v-if="validatedBrandsForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <!-- Arranjo de crédito -->
              <label>Arranjo de crédito</label>
              <ValidationProvider v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedBrandsForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoBrand.PaymentSchemeCredit"
                />

                <div class="invalid-feedback d-block" v-if="validatedBrandsForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveBrands()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" :no-close-on-esc="false" centered id="mFilter" title="Filtros">
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Código</label>
          <input class="form-control" type="text" v-model="filter.Code" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Nome</label>
          <input class="form-control" type="text" v-model="filter.Name" v-on:keyup.enter="Filter()" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button @click="Filter()" class="btn btn-primary" title="Pesquisar" v-b-tooltip.hover.bottom variant="primary">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Brand', 'Add')"
      class="btn-float success"
      href="#"
      title="Novo campo"
      v-b-tooltip.hover
      v-on:click="OpenBrands($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import decimalField from "../common/decimal-field.vue";

export default {
  name: "Brand",
  components: {
    decimalField
  },
  ListBrand: [],
  data() {
    return {
      modalTitle: "Novo Campo",
      labelName: "Controller",
      Brands: [],
      Brand: [],
      disabled: 0,
      countFilter: 0,
      idBrands: 0,
      selected_brands: [],
      brands_list: [],

      infoBrand: {
        Id: null,
        Code: null,
        Name: "",
        CodeFacilitator: null,
        PaymentSchemeCredit: null,
        PaymentSchemeDebit: null,
        IsExcluded: false
      },
      filter: {
        Name: null,
        Code: null
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      validatedBrandsForm: false,

      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber"() {
      this.ListBrand();
    },
    "pagination.RowsPerPage"() {
      this.ListBrand();
    }
  },
  mounted() {
    this.ListBrand();
  },
  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListBrand();
    },
    ResetFilter() {
      this.filter = {
        Code: null,
        Name: null
      };
    },

    OpenBrands(e, index, view) {
      e.preventDefault();
      this.validatedBrandsForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoBrand();

      if (view == undefined && index != undefined) {
        // Edit
        this.modalTitle = "Editar módulo";
        this.pOpened = index;
        this.isSeeing = false;

        this.GetBrands(this.Brands[index].Id);
      } else if (view == undefined && index == undefined) {
        // Add new
        this.modalTitle = "Novo Módulo";
        this.pOpened = null;
        this.isSeeing = false;
      } else {
        // View
        this.modalTitle = "Detalhes do módulo";
        this.pOpened = index;
        this.isSeeing = true;

        this.GetBrands(this.Brands[index].Id);
      }
      this.$bvModal.show("mFormBrands");
    },
    SaveBrands() {
      this.validatedBrandsForm = true;
      this.$refs.BrandsValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            this.$store
              .dispatch("AddBrand", {
                Name: this.infoBrand.Name,
                CodeFacilitator: this.infoBrand.CodeFacilitator,
                PaymentSchemeCredit: this.infoBrand.PaymentSchemeCredit,
                PaymentSchemeDebit: this.infoBrand.PaymentSchemeDebit
              })
              .then(() => {
                this.$makeToast("O campo foi cadastrado com sucesso.", "success", "Campo cadastrado");
                this.$bvModal.hide("mFormBrands");
                this.ListBrand();
              })
              .catch(error => {
                this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao criar campo", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            this.$store
              .dispatch("UpdateBrand", {
                Id: this.infoBrand.Id,
                Code: this.infoBrand.Code,
                Name: this.infoBrand.Name,
                CodeFacilitator: this.infoBrand.CodeFacilitator,
                PaymentSchemeCredit: this.infoBrand.PaymentSchemeCredit,
                PaymentSchemeDebit: this.infoBrand.PaymentSchemeDebit
              })
              .then(() => {
                this.$makeToast("O Campo foi atualizado com sucesso.", "success", "Campo atualizado");
                this.$bvModal.hide("mFormBrands");
                this.ListBrand();
              })
              .catch(error => {
                this.$makeToast("Erro ao atualizar campo, tente novamente.", "danger", "Erro ao atualizar campo", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },

    GetBrands(id) {
      this.loadingModal = true;
      
      if (this.id != 0) {
        this.$store
          .dispatch("GetBrands", { id: id })
          .then(response => {
            this.infoBrand = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    GetParamsData(deletePagination = false) {
      let data = {
        ...this.pagination,

        Code: this.filter.Code,
        Name: this.filter.Name,

        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name,
        "Object.CodeFacilitator": this.filter.CodeFacilitator,
        "Object.PaymentSchemeCredit": this.filter.PaymentSchemeCredit,
        "Object.PaymentSchemeDebit": this.filter.PaymentSchemeDebit
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    GetReport(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = this.GetParamsData(true);
      this.$store
        .dispatch("ReportBrands", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetListBrand() {
      this.ResetFilter();
      this.ListBrand();
    },
    ResetInfoBrand() {
      this.selected_Brand = null;
      this.infoBrand = {
        Id: null,
        Code: null,
        Name: "",
        CodeFacilitator: null,
        PaymentSchemeCredit: null,
        PaymentSchemeDebit: null
      };
    },
    ListBrand() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;

      let data = {
        ...this.pagination,
        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListBrands", { params: data })
        .then(response => {
          this.Brands = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },

    IsOnSelectedBrandsList(BrandsCode) {
      let result = this.infoBrand.PaymentSchemeDebit.find(elm => {
        return elm.Code == BrandsCode;
      });
      return result == undefined ? false : true;
    },

    ConfirmDeleteBrands(Name, Id) {
      this.$makeMsgBox("Você tem certeza que deseja remover o item " + Name + " ?", "Confirmar", this.DeleteBrands, Id);
    },

    DeleteBrands(Id) {
      this.$store
        .dispatch("DeleteBrand", { id: Id })
        .then(() => {
          this.$makeToast("O Item foi removido com sucesso.", "success", "Removido!");
          this.ListBrand();
          this.$bvModal.hide("mFormBrands");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao remover módulo.", error);
        });
    },

    preventDecimal(e) {
      if (e.Code == "Comma" || e.Code == "Period" || e.Code == "Minus") {
        e.preventDefault();
      }
    }
  }
};
</script>
<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
td {
  padding: 10px;
}
.tdEspaco {
  display: table;
  float: left;
  margin-right: 10px;
}
table {
  border-spacing: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/brand.vue